import { Component, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubSink } from 'subsink';

@Component({
  selector: 'kion-platform-menu',
  templateUrl: './platform-menu.component.html',
  styleUrls: ['./platform-menu.component.scss']
})
export class PlatformMenuComponent implements OnDestroy {
  @Input() project: 'LR' | 'FS' | 'Dematic' | string;

  subSink: SubSink;
  isCheckout: boolean;

  constructor(route: ActivatedRoute) {
    this.subSink = new SubSink();
    this.subSink.sink = route.data.subscribe(
      data => {
        if (data.checkout) {
          this.isCheckout = true;
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
